import PropTypes from 'prop-types';
import React, {memo} from 'react';

import {COMPONENTS_MAP} from '../../../constants/components';

export const MessageItem = memo(({message}) => {
  const Component = COMPONENTS_MAP[message.type] || COMPONENTS_MAP.default;
  return <Component message={message} />;
});

MessageItem.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired
  }).isRequired
};
